var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["detail", _vm.type == 2 || _vm.type == 3 ? "detail1" : "detail2"],
    },
    [
      _vm.detail.jiaoyiquanshu_id == "有效" ||
      _vm.detail.jiaoyiquanshu_id == "暂缓" ||
      _vm.detail.jiaoyiquanshu_id == "预定"
        ? _c(
            "div",
            [
              _c(
                "swiper",
                {
                  ref: "mySwiper",
                  class: [_vm.type == 1 ? "swiper1" : "swiper"],
                  attrs: {
                    options: _vm.swiperOption,
                    "not-next-tick": _vm.notNextTick,
                  },
                },
                [
                  _vm._l(_vm.detail.pic_list, function (pic, index) {
                    return _c("swiper-slide", { key: pic.pic_path }, [
                      _c("img", {
                        staticClass: "swiper-image",
                        attrs: { src: pic.pic_path },
                        on: {
                          click: function ($event) {
                            return _vm.showImagePreview(pic.pic_path, "pic")
                          },
                        },
                      }),
                      _vm._v(" "),
                      index == 0 &&
                      _vm.detail.vr_addr &&
                      _vm.detail.is_vr == "是"
                        ? _c("img", {
                            staticClass: "vr",
                            attrs: { src: require("../images/vr.png") },
                            on: {
                              click: function ($event) {
                                return _vm.gotoVr(_vm.detail.vr_addr)
                              },
                            },
                          })
                        : _vm._e(),
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "swiper-pagination",
                    attrs: { slot: "pagination" },
                    slot: "pagination",
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.type == 2 || _vm.type == 3,
                      expression: "type == 2 || type == 3",
                    },
                  ],
                  staticClass: "detail-info",
                },
                [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.detail.xiaoqumingcheng_id)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "base_previes" }, [
                    _c("div", [
                      _c("span", { staticClass: "lable" }, [
                        _vm._v(_vm._s(["售价", "租金"][_vm.type - 2])),
                      ]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.shoujia +
                              (_vm.type == 2 ? "万元" : "元/月")
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", { staticClass: "lable" }, [_vm._v("房型")]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(_vm.detail.shi) +
                            "室" +
                            _vm._s(_vm.detail.ting) +
                            "厅"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", { staticClass: "lable" }, [
                        _vm._v("建筑面积"),
                      ]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.detail.taoneimianji) + "m²"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.detail.biaoqian && _vm.detail.biaoqian.length > 0
                    ? _c(
                        "div",
                        { staticClass: "tags" },
                        _vm._l(_vm.detail.biaoqian, function (tag, index) {
                          return _c(
                            "span",
                            { key: index, staticClass: "tag" },
                            [_vm._v(_vm._s(tag.name))]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type == 3
                    ? _c(
                        "div",
                        { staticClass: "zf-base" },
                        _vm._l(_vm.zfBase, function (base, index) {
                          return _c(
                            "span",
                            {
                              key: index,
                              class: [
                                "base",
                                "base" + (index + 1),
                                {
                                  had:
                                    _vm.detail.peizhixinxi &&
                                    _vm.detail.peizhixinxi.includes(base),
                                },
                              ],
                            },
                            [_vm._v(_vm._s(base))]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "info" }, [
                    _vm.type == 2
                      ? _c("span", { staticClass: "short" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("单价："),
                          ]),
                          _vm._v(
                            _vm._s(
                              Math.floor(
                                ((_vm.detail.shoujia * 10000) /
                                  _vm.detail.taoneimianji) *
                                  100
                              ) / 100
                            ) + "元/平"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "short" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("朝向：")]),
                      _vm._v(_vm._s(_vm.detail.chaoxiang_id)),
                    ]),
                    _vm._v(" "),
                    _vm.isManager
                      ? _c("span", { staticClass: "short" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("楼层："),
                          ]),
                          _vm._v(
                            _vm._s(_vm.detail.suozaiceng) +
                              "/" +
                              _vm._s(_vm.detail.gongjiceng)
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "short" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("楼型：")]),
                      _vm._v(_vm._s(_vm.detail.louxing_id)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "short" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("电梯：")]),
                      _vm._v(_vm._s(_vm.detail.dianti_id)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "short" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("车位：")]),
                      _vm._v(_vm._s(_vm.detail.chewei)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "short" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("装修：")]),
                      _vm._v(_vm._s(_vm.detail.zhuangxiu_id || "暂无")),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "short" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("年代：")]),
                      _vm._v(_vm._s(_vm.detail.niandai || "暂无")),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "short" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("用途：")]),
                      _vm._v(_vm._s(_vm.detail.yongtu_id || "暂无")),
                    ]),
                    _vm._v(" "),
                    _vm.isManager
                      ? _c("span", { staticClass: "short" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("房源编号："),
                          ]),
                          _vm._v(_vm._s(_vm.detail.bianhao || "暂无")),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isManager
                      ? _c("span", { staticClass: "short" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("发布状态："),
                          ]),
                          _vm._v(
                            _vm._s(
                              _vm.detail.status == "01" ? "已发布" : "未发布"
                            )
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isManager
                      ? _c("span", { staticClass: "short" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("已收定金："),
                          ]),
                          _vm._v(
                            _vm._s(_vm.detail.is_dj == "yes" ? "已收" : "未收")
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isManager
                      ? _c("span", { staticClass: "short" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("钥匙位置："),
                          ]),
                          _vm._v(_vm._s(_vm.detail.weizhi || "暂无")),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "long" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("产权性质："),
                      ]),
                      _vm._v(_vm._s(_vm.detail.chanquansuoyou_id || "暂无")),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "long" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("供暖方式："),
                      ]),
                      _vm._v(_vm._s(_vm.detail.gongnuanfangshi_id || "暂无")),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "long" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("小区：")]),
                      _vm._v(_vm._s(_vm.detail.xiaoqumingcheng_id || "暂无")),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "long" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("房源状态："),
                      ]),
                      _vm._v(_vm._s(_vm.detail.jiaoyiquanshu_id || "暂无")),
                    ]),
                    _vm._v(" "),
                    _vm.shareContact && _vm.jingjiren.length > 0
                      ? _c("span", { staticClass: "long" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("联系人："),
                          ]),
                          _vm._v(_vm._s(_vm.jingjiren[0].login_name)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shareContact &&
                    _vm.shareContact.length == 11 &&
                    _vm.jingjiren.length > 0
                      ? _c("span", { staticClass: "long" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("联系电话："),
                          ]),
                          _c(
                            "a",
                            { attrs: { href: "tel:" + _vm.shareContact } },
                            [_vm._v(_vm._s(_vm.shareContact))]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isManager
                      ? _c("span", { staticClass: "long" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("房源描述："),
                          ]),
                          _vm._v(_vm._s(_vm.detail.miaoshu || "暂无")),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "huixingfenjian" },
                    [
                      _c("div", { staticClass: "huixingfenjian_title" }, [
                        _vm._v("户型分间"),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.detail.pic_hxt, function (hxt, index) {
                        return index == 0
                          ? _c("img", {
                              key: index,
                              staticClass: "huixingfenjian_img",
                              attrs: { src: hxt.pic_path },
                              on: {
                                click: function ($event) {
                                  return _vm.showImagePreview(
                                    hxt.pic_path,
                                    "hxt"
                                  )
                                },
                              },
                            })
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.type == 2
                    ? _c(
                        "div",
                        {
                          staticClass: "genduofangyuan",
                          on: {
                            click: function ($event) {
                              _vm.showfangyuanInfoWrapper = true
                            },
                          },
                        },
                        [_vm._v("更多房源信息")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    ref: "map",
                    staticClass: "baidu-map",
                    on: { click: _vm.handleMap },
                  }),
                  _vm._v(" "),
                  _vm.isManager
                    ? _c("div", { staticClass: "btn-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "btn-item btn-genjin",
                            on: { click: _vm.goToGenjin },
                          },
                          [_vm._v("查看跟进")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn-item btn-my-share",
                            on: { click: _vm.goToShare },
                          },
                          [_vm._v("我的分享列表")]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isManager && ["2"].includes(_vm.type)
                    ? _c("div", { staticClass: "btn-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "btn-item btn-genjin",
                            on: { click: _vm.gotoContract },
                          },
                          [_vm._v("签署两书")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn-item btn-my-share",
                            on: { click: _vm.goToContractList },
                          },
                          [_vm._v("我的两书合同")]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isManager && ["3"].includes(_vm.type)
                    ? _c("div", { staticClass: "btn-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "btn-item btn-genjin",
                            on: { click: _vm.gotoContract },
                          },
                          [_vm._v("发起合同")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "btn-item btn-my-share",
                            on: { click: _vm.goToContractList },
                          },
                          [_vm._v("我的合同列表")]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isManager && _vm.showShaoShi == "yes"
                    ? _c("div", { staticClass: "btn-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "btn-item btn-genjin",
                            on: { click: _vm.yaoshilingong },
                          },
                          [_vm._v("钥匙领用")]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.type == 1,
                      expression: "type == 1",
                    },
                  ],
                },
                [
                  _c("div", { staticClass: "intro" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.detail.loupan)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tags" },
                      _vm._l(_vm.detail.biaoqian, function (tag, index) {
                        return _c("span", { key: index, staticClass: "tag" }, [
                          _vm._v(_vm._s(tag.name)),
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "price" }, [
                      _vm._v(" 均价："),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(_vm.detail.junjia) + " 元/平"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "address" }, [
                      _vm._v(
                        " 户型：" +
                          _vm._s(_vm.detail.shi) +
                          "市" +
                          _vm._s(_vm.detail.ting) +
                          "厅" +
                          _vm._s(_vm.detail.wei) +
                          "卫" +
                          _vm._s(_vm.detail.chu) +
                          "厨"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "address" }, [
                      _vm._v(" 地址：" + _vm._s(_vm.detail.xiangxidizhi)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "address" }, [
                      _vm._v(" 开盘：" + _vm._s(_vm.detail.shoucikaipanriqi)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "address" }, [
                      _vm._v(" 装修：" + _vm._s(_vm.detail.zhuangxiu)),
                    ]),
                    _vm._v(" "),
                    _vm.shareContact && _vm.jingjiren.length > 0
                      ? _c("div", { staticClass: "address" }, [
                          _vm._v(
                            " 联系人：" + _vm._s(_vm.jingjiren[0].login_name)
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shareContact && _vm.shareContact.length == 11
                      ? _c("div", { staticClass: "address" }, [
                          _vm._v(" 联系电话："),
                          _c(
                            "a",
                            { attrs: { href: "tel:" + _vm.shareContact } },
                            [_vm._v(_vm._s(_vm.shareContact))]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info" }, [
                    _c("div", { staticClass: "title" }, [_vm._v("楼盘信息")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("开发商："),
                      ]),
                      _vm._v(_vm._s(_vm.detail.kaifashang)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("交房时间："),
                      ]),
                      _vm._v(_vm._s(_vm.detail.jiaofangshijian)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("产权年限："),
                      ]),
                      _vm._v(_vm._s(_vm.detail.chanquannianxian)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "genduofangyuan",
                        on: {
                          click: function ($event) {
                            _vm.showXinfangWrapper = true
                          },
                        },
                      },
                      [_vm._v("更多楼盘信息")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "huixingfenjian" },
                    [
                      _c("div", { staticClass: "huixingfenjian_title" }, [
                        _vm._v("户型分间"),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.detail.pic_hxt, function (hxt, index) {
                        return index == 0
                          ? _c("img", {
                              key: index,
                              staticClass: "huixingfenjian_img",
                              attrs: { src: hxt.pic_path },
                              on: {
                                click: function ($event) {
                                  return _vm.showImagePreview(
                                    hxt.pic_path,
                                    "hxt"
                                  )
                                },
                              },
                            })
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", {
                    ref: "map2",
                    staticClass: "baidu-map",
                    on: { click: _vm.handleMap },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "describe" }, [
                    _c("div", { staticClass: "describe_title" }, [
                      _vm._v("户型卖点"),
                    ]),
                    _vm._v(_vm._s(_vm.detail.huxingmaidian) + "\n      "),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.daikan.length != 0
                ? _c("div", { staticClass: "daikan" }, [
                    _c("div", { staticClass: "daikan-title" }, [
                      _vm._v("经纪人带看反馈"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      _vm._l(_vm.daikan, function (item, index) {
                        return _c("li", { key: index }, [
                          _c("div", { staticClass: "daikan-header" }, [
                            _c("div", { staticClass: "daikan-info" }, [
                              _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(item.login_name)),
                              ]),
                              _vm._v(
                                " 共带看本房" +
                                  _vm._s(item.fangbencishu) +
                                  "次 "
                              ),
                              _c("br"),
                              _vm._v(_vm._s(item.daikanshijian) + " 带看过"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "daikan-phone",
                                attrs: { href: "tel:" + item.user_phone },
                              },
                              [
                                _c("svgicon", {
                                  attrs: {
                                    name: "phone",
                                    width: ".6rem",
                                    height: ".6rem",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "daikan-sms",
                                attrs: { href: "sms:" + item.user_phone },
                              },
                              [
                                _c("svgicon", {
                                  attrs: {
                                    name: "sms",
                                    width: ".6rem",
                                    height: ".6rem",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "daikan-content" }, [
                            _vm._v(_vm._s(item.jingjiren_miaoshu)),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.xiangsi.length != 0
                ? _c(
                    "div",
                    { staticClass: "xiangsi" },
                    [
                      _c("div", { staticClass: "xiangsi-title" }, [
                        _vm._v("相似房源"),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.xiangsi, function (house, index) {
                        return _c("house-item", {
                          key: index,
                          attrs: { house: house, type: _vm.type },
                          on: { handleHosue: _vm.handleHosue },
                        })
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showJingJiRenWrapper
                ? _c("div", { staticClass: "jingjiren-wrapper" }, [
                    _c("span", {
                      staticClass: "btn-close",
                      on: {
                        click: function ($event) {
                          _vm.showJingJiRenWrapper = false
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "jingjiren" }, [
                      _c("div", { staticClass: "jinjiren-title" }, [
                        _vm._v("咨询经纪人"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(_vm.jingjiren, function (item, index) {
                          return ["房源开发", "房源维护"].includes(
                            item.guishukaifa
                          ) || _vm.shareContact
                            ? _c("li", { key: index }, [
                                !item.pic_path
                                  ? _c("img", {
                                      staticClass: "avater",
                                      attrs: {
                                        src: require("../images/icon-jingjiren.png"),
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                item.pic_path
                                  ? _c("img", {
                                      staticClass: "avater",
                                      attrs: {
                                        src:
                                          "http://wx.jcfyht.cc/Contract/swfupload/files/" +
                                          item.pic_path,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "jinjiren-info" }, [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(item.login_name)),
                                  ]),
                                  _vm._v(_vm._s(item.dept_name)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "jinjiren-xinxika",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showXinXiKaImage(
                                          item.xxk_path
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("信息卡")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "jinjiren-phone",
                                    attrs: { href: "tel:" + item.user_phone },
                                  },
                                  [
                                    _c("svgicon", {
                                      attrs: {
                                        name: "phone",
                                        width: ".6rem",
                                        height: ".6rem",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "jinjiren-sms",
                                    attrs: { href: "sms:" + item.user_phone },
                                  },
                                  [
                                    _c("svgicon", {
                                      attrs: {
                                        name: "sms",
                                        width: ".6rem",
                                        height: ".6rem",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e()
                        }),
                        0
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showfangyuanInfoWrapper
                ? _c("div", { staticClass: "fangyuaninfo-wrapper" }, [
                    _c("span", {
                      staticClass: "btn-close",
                      on: {
                        click: function ($event) {
                          _vm.showfangyuanInfoWrapper = false
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "fangyuaninfo-item" }, [
                      _c("div", { staticClass: "fangyuaninfo-item-title" }, [
                        _vm._v("基础信息"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v(
                          "房源户型：" +
                            _vm._s(_vm.detail.shi) +
                            "室" +
                            _vm._s(_vm.detail.ting) +
                            "厅"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v(
                          "套内面积：" + _vm._s(_vm.detail.taoneimianji) + "m²"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v(
                          "交易状态：" + _vm._s(_vm.detail.jiaoyiquanshu_id)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v("现状：" + _vm._s(_vm.detail.xianzhuang)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v(
                          "证件类型：" + _vm._s(_vm.detail.zhengjianleixing)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v("建成年代：" + _vm._s(_vm.detail.niandai)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v(
                          "产权性质：" + _vm._s(_vm.detail.chanquansuoyou_id)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v("房屋用途：" + _vm._s(_vm.detail.yongtu_id)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v("户型结构：" + _vm._s(_vm.detail.louxing_id)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v("装修：" + _vm._s(_vm.detail.zhuangxiu_id)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v("电梯：" + _vm._s(_vm.detail.dianti_id)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v("车位：" + _vm._s(_vm.detail.chewei)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v(
                          "供暖方式：" + _vm._s(_vm.detail.gongnuanfangshi_id)
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "fangyuaninfo-item-title border-top" },
                        [_vm._v("交易信息")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v("上次交易：" + _vm._s(_vm.detail.shangcijiaoyi)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v(
                          "原过户价：" + _vm._s(_vm.detail.yuanguohujia) + "万"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v(
                          "抵押状况：" + _vm._s(_vm.detail.diyazhuangkuang)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v(
                          "抵押金额：" + _vm._s(_vm.detail.diyajiner) + "万"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "fangyuaninfo-item-content" }, [
                        _vm._v("土地年限：" + _vm._s(_vm.detail.tudinianxian)),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showXinfangWrapper
                ? _c("div", { staticClass: "xingfang-wrapper" }, [
                    _c("span", {
                      staticClass: "btn-close",
                      on: {
                        click: function ($event) {
                          _vm.showXinfangWrapper = false
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "xingfang-group first-group" }, [
                      _c(
                        "div",
                        { staticClass: "xingfang-item xingfang-item-title" },
                        [
                          _vm._v(
                            _vm._s(_vm.loupan.name) +
                              "【" +
                              _vm._s(_vm.loupan.is_new) +
                              "】"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("楼盘别名")]),
                        _vm._v(_vm._s(_vm.loupan.bie_name)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("参考价格")]),
                        _vm._v(_vm._s(_vm.loupan.cankaojiage) + "元/m²"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("房屋用途")]),
                        _vm._v(_vm._s(_vm.detail.fangwuyongtu)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("物业用途")]),
                        _vm._v(_vm._s(_vm.loupan.wuyeyongtu)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("电梯费用")]),
                        _vm._v(_vm._s(_vm.loupan.diantifeiyong)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("梯户比例")]),
                        _vm._v(
                          _vm._s(_vm.detail.ti) +
                            "梯" +
                            _vm._s(_vm.detail.hu) +
                            "户"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("楼盘特性")]),
                        _vm._v(_vm._s(_vm.loupan.loupantexing)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("周边学校")]),
                        _vm._v(_vm._s(_vm.loupan.zhoubianxuexiao)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("地铁/轻轨")]),
                        _vm._v(_vm._s(_vm.loupan.ditieqinggui)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "xingfang-group" }, [
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("区域位置")]),
                        _vm._v(_vm._s(_vm.loupan.qx)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("楼盘地址")]),
                        _vm._v(
                          _vm._s(_vm.loupan.qx) +
                            _vm._s(_vm.loupan.pq) +
                            _vm._s(_vm.loupan.jiedao)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("产权")]),
                        _vm._v(_vm._s(_vm.detail.chanquan)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("楼盘描述")]),
                        _vm._v(_vm._s(_vm.loupan.loupanmiaoshu)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("楼盘备注")]),
                        _vm._v(_vm._s(_vm.loupan.loupanbeizhu)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "xingfang-group" }, [
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("建筑结构")]),
                        _vm._v(_vm._s(_vm.loupan.jianzhujiegou)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("土地使用年限")]),
                        _vm._v(_vm._s(_vm.loupan.tudishiyongnianxian)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("容积率")]),
                        _vm._v(_vm._s(_vm.detail.rongjilv)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("绿化率")]),
                        _vm._v(_vm._s(_vm.detail.lvhualv)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("车位比")]),
                        _vm._v(_vm._s(_vm.detail.cheweibi)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "xingfang-group" }, [
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("物业类型")]),
                        _vm._v(_vm._s(_vm.detail.wuyeleixing)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("物业公司")]),
                        _vm._v(_vm._s(_vm.detail.wuyegongsi)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("物业费")]),
                        _vm._v(_vm._s(_vm.detail.wuyefei) + "平方米/月"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("供暖方式")]),
                        _vm._v(_vm._s(_vm.detail.gongnuanfangshi)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("供水方式")]),
                        _vm._v(_vm._s(_vm.detail.gongshuileixing)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("供电方式")]),
                        _vm._v(_vm._s(_vm.detail.gongdianleixing)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "xingfang-group" }, [
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("责任部门")]),
                        _vm._v(_vm._s(_vm.detail.zerenbumen1)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "xingfang-item" }, [
                        _c("span", [_vm._v("责任人")]),
                        _vm._v(_vm._s(_vm.detail.zerenren1 || "暂无")),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showGenJinWrapper
                ? _c("div", { staticClass: "genjin-wrapper" }, [
                    _c("div", { staticClass: "genjin-wrapper-inner" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.genjin,
                            expression: "genjin",
                          },
                        ],
                        attrs: { placeholder: "请输入跟进信息" },
                        domProps: { value: _vm.genjin },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.genjin = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "commit-genjin",
                          on: { click: _vm.commitGenJin },
                        },
                        [_vm._v("提交")]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showShareCover
                ? _c(
                    "div",
                    {
                      staticClass: "share-cover",
                      on: {
                        click: function ($event) {
                          _vm.showShareCover = false
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: { src: require("../images/share-it.png") },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isManager && _vm.source == "near"
                ? _c("div", { staticClass: "detail-bottom single" }, [
                    _c(
                      "span",
                      { staticClass: "btn-daka", on: { click: _vm.daka } },
                      [_vm._v("打卡")]
                    ),
                  ])
                : _c("div", { staticClass: "detail-bottom" }, [
                    _c(
                      "span",
                      {
                        staticClass: "btn-attention",
                        style: {
                          color: _vm.detail.guanzhu == 0 ? "#999" : "#3385ff",
                        },
                        on: { click: _vm.attention },
                      },
                      [
                        _c("svgicon", {
                          attrs: {
                            name:
                              _vm.detail.guanzhu == 0
                                ? "heart-hollow"
                                : "heart",
                            width: ".4rem",
                            height: ".4rem",
                            color: _vm.detail.guanzhu == 0 ? "#999" : "#3385ff",
                          },
                        }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v("\n        关注\n      "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "btn-share",
                        on: {
                          click: function ($event) {
                            _vm.showShareCover = true
                          },
                        },
                      },
                      [_vm._v("分享房源")]
                    ),
                    _vm._v(" "),
                    _vm.type != 1
                      ? _c(
                          "span",
                          {
                            staticClass: "btn-jinjiren",
                            on: {
                              click: function ($event) {
                                _vm.showJingJiRenWrapper = true
                              },
                            },
                          },
                          [_vm._v("咨询经纪人")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type != 1 &&
                    _vm.isManager &&
                    !(_vm.type == 3 && _vm.detail.is_ba == "yes")
                      ? _c(
                          "span",
                          {
                            staticClass: "btn-jinjiren",
                            on: {
                              click: function ($event) {
                                return _vm.checkFenPan()
                              },
                            },
                          },
                          [_vm._v("联系业主")]
                        )
                      : _vm._e(),
                  ]),
            ],
            1
          )
        : _c("div", { staticClass: "no-publish" }, [
            _vm._v("\n    亲！房源已失效～～～\n  "),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }